// extracted by mini-css-extract-plugin
export default {"triggerButton":"SaveButton_triggerButton__o-yh5"};